import { ajaxSend } from '../../../api/api';

export function originalEmailGet(payload: { url: string }) {
  const { url } = payload;
  return ajaxSend({
    method: 'GET',
    path: `${url}`,
  });
}

export function originalEmailGetByType(payload: { url: string; type: string }) {
  const { url, type } = payload;
  return ajaxSend({
    method: 'GET',
    path: `${url}/content/${type}`,
  });
}
